interface ExpressRowInputs {
  checkoutV2: boolean;
  expressWalletsTop: boolean;
  walletChargesInline: boolean;
  giftOrder: boolean;
  inlineChargeAmountInCents: number | undefined;
}

/**
 * the express row needs the inline charge the accordion wallets use, so it is v2-only with a priced total.
 * a gift order or an amount gift card has none: its wallets wait in the form until the gift fields are valid.
 */
export function expressRowAmount({
  checkoutV2,
  expressWalletsTop,
  walletChargesInline,
  giftOrder,
  inlineChargeAmountInCents,
}: ExpressRowInputs): number | undefined {
  return checkoutV2 && expressWalletsTop && walletChargesInline && !giftOrder ? inlineChargeAmountInCents : undefined;
}
